// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Xo-z","imageAndVideoCount":"Yo-z","imageAndVideoContainer":"Zo-z","viewAllReviews":"_o-z"};